import React from "react";
import { Link } from "react-router-dom";
import TopicOne from "../meta-trader-5-mobile-contents/TopicOne";

const MetaTrader5MobileContentOne = () => {
  return (
    <>
      <TopicOne />

      <div className="how__work__platform">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="thumb-left">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/platforms/meta_trader_5_mobile/meta_trader_5_mobile_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="content-right">
                <h2> Professional Trading On the Go</h2>
                <p>
                  MetaTrader 5 Mobile brings institutional-grade trading
                  technology to your smartphone or tablet. Designed for active
                  traders, the app delivers advanced order management,
                  interactive charts, and real-time data feeds across global
                  markets. Whether you trade Forex, Commodities, or
                  Cryptocurrencies, MT5 Mobile ensures every decision is backed
                  by accuracy and control, no matter where you are. With
                  seamless synchronization across all your devices, you can pick
                  up exactly where you left off without missing a beat. The
                  platform’s optimized layout provides fast navigation, precise
                  charting, and smooth execution even during volatile
                  conditions. No matter your trading style, MT5 Mobile keeps you
                  informed, agile, and ready to act at any moment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MetaTrader5MobileContentOne;
